module.exports = __webpack_public_path__ + "img/1F1E6-1F1FA.9cecad6d.svg";